import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';
const Carousels = () => {
  return (
    <div className='car'>
      <Carousel touch='true'>
      <Carousel.Item>
        <div className="card border-0" style={{"width": "18rem"}}>
                <img src="https://www.cgmagonline.com/wp-content/uploads/2024/02/the-best-isekai-anime-of-all-time-ranked-2024-02-06_23-26-41_222846.jpg" 
                className="card-img-top card-images rounded" alt="anime poster"/>
                <div className="card-body">
                <h5 className="card-title">Reincarnation Anime Quiz!</h5>
                <Link to="/reincarnation" className="btn">Start Quiz</Link>
            </div>
        </div>
      </Carousel.Item>
        
      <Carousel.Item>
      <div className="card border-0" style={{"width": "18rem"}}>
                <img src="https://static0.gamerantimages.com/wordpress/wp-content/uploads/2021/08/best-fantasy-anime-featured-image.jpg" 
                className="card-img-top card-images rounded" alt="anime poster"/>
                <div className="card-body">
                <h5 className="card-title">Adventure Anime Quiz!</h5>
                <Link to="/reincarnation" className="btn">Start Quiz</Link>
            </div>
        </div>
      </Carousel.Item>

      <Carousel.Item>
      <div className="card border-0" style={{"width": "18rem"}}>
                <img src="/error.jpg" className="card-img-top card-images rounded" alt="anime poster"/>
                <div className="card-body">
                <h5 className="card-title">Coming soon!</h5>
                <Link to="/reincarnation" className="btn">Start Quiz</Link>
            </div>
        </div>
      </Carousel.Item>
    </Carousel>
    </div>
  );
}

export default Carousels;